export default __webpack_public_path__ + "static/media/sami.ef81aec0.svg";